'use client';

var translations = {
    'Add a skill': 'Thêm kỹ năng',
    'Or select from suggested list': 'Hoặc chọn từ danh sách gợi ý',
    'Select all': 'Chọn tất cả',
    'You can get maximum': 'Bạn chỉ có thể thêm tối đa',
    'skills on profile': 'kỹ năng vào hồ sơ'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
